import { DropzoneProps } from '@mantine/dropzone';
import DropzoneInput from './DropzoneInput';

export default DropzoneInput;

export interface DropzoneInputProps {
  label: string;
  error?: string;
  loading?: boolean;
  errorUpload?: boolean;
  defaultValue?: string;
  value?: string;
  withAsterik?: boolean;
  onHandleDrop?: (files: File[], base64url: string) => void;
}
